import { AppStore as AppStoreInterface } from 'interfaces';
import { Lang } from 'enums';
import { makeAutoObservable } from 'mobx';

class AppStore implements AppStoreInterface {
  constructor() {
    makeAutoObservable(this);
  }

  lang: Lang = Lang.UK;
  id: string = '';
  orderId: string = '';

  setId = (id: string): void => {
    this.id = id;
  };

  setLang = (lang: Lang): void => {
    this.lang = lang;
  };

  setOrderId = (orderId: string): void => {
    this.orderId = orderId;
  };
}

export default AppStore;
